import { generateClient, isCancelError } from "aws-amplify/api";

const client = generateClient();

export async function requestGetTerms(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_GET_TERMS",
      payload: { request: null },
    });
    const { id } = payload;

    const request = client.graphql({
      query: getTermsAndConditions,
      variables: { id },
    });
    dispatch({
      type: "REQUEST_GET_TERMS",
      payload: { request },
    });

    const res = await request;

    const terms = res.data.getTermsAndConditions;

    if (!terms) {
      throw new Error("Terms and conditions not found.");
    }

    dispatch({
      type: "GET_TERMS_SUCCESS",
      payload: { terms },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "GET_TERMS_CANCEL",
      });
    } else {
      dispatch({
        type: "GET_TERMS_ERROR",
        error,
      });
    }
  }
}

export async function requestListTermsAcceptance(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_LIST_TERMS_ACCEPTANCE",
      payload: { request: null },
    });

    const { termsID, userID } = payload;

    const request = client.graphql({
      query: termsAcceptancesByUserTerms,
      variables: {
        userID,
        termsAndConditionsID: {
          eq: termsID,
        },
      },
    });

    dispatch({ type: "REQUEST_LIST_TERMS_ACCEPTANCE", payload: { request } });

    const res = await request;

    const { items } = res.data.termsAcceptancesByUserTerms;

    dispatch({
      type: "LIST_TERMS_ACCEPTANCE_SUCCESS",
      payload: {
        items,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "LIST_TERMS_ACCEPTANCE_CANCEL" });
    } else {
      dispatch({ type: "LIST_TERMS_ACCEPTANCE_ERROR", error });
    }
  }
}

export async function requestAcceptTerms(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_ACCEPT_TERMS", payload: { request: null } });

    const { termsID: termsAndConditionsID, userID } = payload;

    const request = client.graphql({
      query: createUserTermsAcceptance,
      variables: {
        input: {
          userID,
          termsAndConditionsID,
          acceptedAt: new Date().toISOString(),
        },
      },
    });

    dispatch({ type: "REQUEST_ACCEPT_TERMS", payload: { request } });

    const res = await request;

    const acceptance = res.data.createUserTermsAcceptance;

    dispatch({
      type: "ACCEPT_TERMS_SUCCESS",
      payload: {
        acceptance,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "ACCEPT_TERMS_CANCEL" });
    } else {
      dispatch({ type: "ACCEPT_TERMS_ERROR", error });
    }
  }
}

export async function requestRemoveTermsAcceptance(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_REMOVE_TERMS_ACCEPTANCE",
      payload: { request: null },
    });

    const { acceptanceID } = payload;

    const request = client.graphql({
      query: deleteUserTermsAcceptance,
      variables: {
        input: {
          id: acceptanceID,
        },
      },
    });

    dispatch({ type: "REQUEST_REMOVE_TERMS_ACCEPTANCE", payload: { request } });

    const res = await request;

    const acceptance = res.data.deleteUserTermsAcceptance;

    dispatch({
      type: "REMOVE_TERMS_ACCEPTANCE_SUCCESS",
      payload: {
        acceptance,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "REMOVE_TERMS_ACCEPTANCE_CANCEL" });
    } else {
      dispatch({ type: "REMOVE_TERMS_ACCEPTANCE_ERROR", error });
    }
  }
}

export async function clearTermsError(dispatch) {
  dispatch({ type: "CLEAR_TERMS_ERROR" });
}

export async function clearTermsStatus(dispatch) {
  dispatch({ type: "CLEAR_TERMS_STATUS" });
}

const getTermsAndConditions = /* GraphQL */ `
  query GetTermsAndConditions($id: ID!) {
    getTermsAndConditions(id: $id) {
      id
      version
      contents {
        items {
          id
          language
          content
          termsAndConditionsID
          createdAt
          updatedAt
        }
        nextToken
      }
      effectiveDate
      isActive
      createdAt
      updatedAt
    }
  }
`;

const termsAcceptancesByUserTerms = /* GraphQL */ `
  query TermsAcceptancesByUserTerms(
    $userID: ID
    $termsAndConditionsID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserTermsAcceptanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    termsAcceptancesByUserTerms(
      userID: $userID
      termsAndConditionsID: $termsAndConditionsID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        termsAndConditionsID
        termsAndConditions {
          id
          version
          effectiveDate
          isActive
          createdAt
          updatedAt
        }
        acceptedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const createUserTermsAcceptance = /* GraphQL */ `
  mutation CreateUserTermsAcceptance($input: CreateUserTermsAcceptanceInput!) {
    createUserTermsAcceptance(input: $input) {
      id
      userID
      termsAndConditionsID
      termsAndConditions {
        id
        version
        effectiveDate
        isActive
        createdAt
        updatedAt
      }
      acceptedAt
      createdAt
      updatedAt
    }
  }
`;

const deleteUserTermsAcceptance = /* GraphQL */ `
  mutation DeleteUserTermsAcceptance($input: DeleteUserTermsAcceptanceInput!) {
    deleteUserTermsAcceptance(input: $input) {
      id
      userID
      termsAndConditionsID
      termsAndConditions {
        id
        version
        effectiveDate
        isActive
        createdAt
        updatedAt
      }
      acceptedAt
      createdAt
      updatedAt
    }
  }
`;
